export const SPOTLIGHT_FORM_FACTOR_GATE = 'LiveChat:SpotlightFormFactor';